import { Box, Text } from '@factorialco/deprecated-design-system'

import DayPicker from 'modules/core/components/DayPicker'
import FormRow from 'modules/core/components/FormRow'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'

interface Props {
  value: string
  nextAvailableDate: string
  onChange: (value: string) => void
}

function ContractActivationDate({ value, nextAvailableDate, onChange }: Props) {
  /**
   * We are adding 1 day as between activity periods, there should be at least 1 day of inactivity.
   * This ensures the two activity periods are not consecutive without resting.
   */
  const minDate = stringToDate(nextAvailableDate, 'backend').add(1, 'days').toDate()

  return (
    <FormRow>
      <Box gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s4" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.header.pause_resume.resume_modal.activity_start_date_label')}
          </Text>
          <ContractTooltip
            information={i18n.t('contract_versions.header.pause_resume.resume_modal.tooltip')}
            icon="info-circle-line"
          />
        </Box>
        <DayPicker value={value} onChange={onChange} minDate={minDate} pin mandatory />
      </Box>
    </FormRow>
  )
}

export default ContractActivationDate
